<template>
    <div class="house-group">
        <h1 class="title">同棟房源</h1>
        <div class="list">
            <div class="item" v-for="(item, index) in houseGroupList" :key="index" @click="toHouse(item.houseCid)">
                <div class="house-img">
                    <img :class="{'is-width': getImageWidthAndHeight(imageUrl(item.imageUrl)), 'is-height': !getImageWidthAndHeight(imageUrl(item.imageUrl))}" :src="imageUrl(item.imageUrl)" alt="">
                </div>
                <div class="house-info">
                    <div class="title">
                        {{item.name}}
                    </div>
                    <div class="spec">
                        <span class="house-type">
                            {{houseType(item.houseType)}}
                        </span>
                        <span>
                            {{item.size}}坪
                        </span>
                    </div>
                    <div class="address">
                        <img src="@/assets/img/shareHouse/address_gray.svg" alt="">
                        {{item.address}}
                    </div>
                    <div v-if="item.goodToLive || item.featureList.length" class="tags">
                        <div v-if="item.goodToLive" class="good-to-live">
                            認證房源
                        </div>
                        <div class="feature" v-for="(feature, fIndex) in item.featureList" :key="fIndex">
                            {{feature.itemName}}
                        </div>
                    </div>
                    <div class="rent-price">
                        {{toCurrency(item.rentMonthly)}}
                        <span class="unit">
                            元
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import constant from '@/constant'

export default {
    data () {
        return {
            ispreviewHousePage: false,
            flag: {
                isWidth: true
            }
        }
    },
    watch: {
        $route:{
            handler: function (val) {
                if(val.name == 'previewHouse'){
                    this.ispreviewHousePage = true
                }else{
                    this.ispreviewHousePage = false
                }
            },
            immediate: true,
            deep: true
        },
    },
    methods: {
        imageUrl: function (url) {
            return constant.imageUrl+url
        },
        toHouse: function (houseCid) {
            if(!this.ispreviewHousePage){
                this.$router.push({name: 'shareHouse', query:{cid: houseCid}})
            }
        },
        getImageWidthAndHeight: function (val) {
            
            let newImg = new Image()
            newImg.src = val
            // setTimeout(()=>{
                console.log(newImg.height)
                console.log(newImg.width)
                if( newImg.width > newImg.height ){
                    return true
                }else{
                    return false
                }
            // }, 500)
            // console.log(newImg)
            
        },
    },
    computed: {
        ...mapGetters({
            houseGroupList: 'GET_SHARE_HOUSE_HOUSE_GROUP',
        })
    },
}
</script>
<style lang="scss" scoped>
    .house-group{
        position: relative;
        width: 100%;
        h1.title{
            margin-bottom: 20px;
            font-size: 28px;
            color: #3a455f;
        }
        >.list{
            >.item{
                display: flex;
                align-items: flex-start;
                margin-bottom: 25px;
                cursor: pointer;
                .house-img{
                    width: 100px;
                    height: 100px;
                    margin-right: 12px;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 4px;
                    >img{
                        &.is-width{
                            height: 100%;
                        }
                        &.is-height{
                            width: 100%;
                        }
                    }
                }
                .house-info{
                    .title{
                        font-size: 16px;
                        font-weight: 400;
                        margin-bottom: 8px;
                    }
                    .spec{
                        font-size: 12px;
                        color: #9a9999;
                        margin-bottom: 8px;
                        .house-type{
                            position: relative;
                            margin-right: 13px;
                            &::after{
                                content: '';
                                position: absolute;
                                width: 1px;
                                height: 8px;
                                top: 5px;
                                right: -6px;
                                background: #9a9999;
                            }
                        }
                    }
                    .address{
                        display: flex;
                        align-items: center;
                        font-size: 12px;
                        color: #9a9999;
                        margin-bottom: 8px;
                        >img{
                            margin-right: 6px;
                        }
                    }
                    .tags{
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        font-size: 12px;
                        line-height: 22px;
                        >div{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border-radius: 4px;
                            margin-right: 6px;
                            height: 22px;
                            padding: 0 4px;
                            margin-bottom: 8px;
                        }
                        .good-to-live{
                            background-color: #d7effe;
                            color: #01bdfe;
                        }
                        .feature{
                            background-color: rgba($color: #9a9999, $alpha: 0.1);
                            color: #9a9999;
                        }
                    }
                    .rent-price{
                        font-size: 16px;
                        font-weight: 600;
                        color: #fb6b63;
                        .unit{
                            font-size: 12px;
                        }
                    }
                }
            }
        }
    }
    @media (max-width: 992px) {
        .house-group{
            h1.title{
                margin-bottom: 16px;
                font-size: 20px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shareHouse/houseGroup.vue